import axios from 'axios';
import get from 'lodash.get';
import { emptyObject } from 'ui-components/default-props/empty';
import { from } from 'rxjs';
import { appendExtraParamsWithPossibleKeyDupes } from '../../services/api/grid-api-extra-params-service';
import { generateApiCollectionFilter } from '../../filters/filter-type-generator';
import { id } from '../../filters/options/customer';
import { FIRST_PAGE, PAGE_SIZE_250 } from '../../services/pagination-service';

const makeParams = (searchTerm, pageNumber, pageSize, extraParams) => {
  let params = {
    pageNumber,
    pageSize,
    searchTerm,
  };
  if (extraParams) {
    params = appendExtraParamsWithPossibleKeyDupes(params, extraParams);
  }

  return params;
};

export const getCustomerSearchResults = (searchTerm) => {
  const request = axios.get(`/customer/autocomplete/${searchTerm}`).then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const getCustomers = (searchTerm, pageNumber = FIRST_PAGE, pageSize = PAGE_SIZE_250, extraParams = undefined) => {
  const params = makeParams(searchTerm, pageNumber, pageSize, extraParams);
  const getRequest = axios.get('/customer/grid', { params });
  const getAndTransform = getRequest.then((response) => {
    const data = get(response, 'data', emptyObject);
    return data;
  });
  const customersData$ = from(getAndTransform);
  return customersData$;
};

export const addCustomerTag = ({ customerIds, tagId }) => {
  const request = axios.post('/customer/tag', { customerIds, tagId });
  return from(request);
};

export const removeCustomerTag = ({ customerIds, tagId }) => {
  const request = axios.delete('/customer/tag', {
    data: {
      customerIds,
      tagId,
    },
  });
  return from(request);
};

export const getCustomersFromQuickSearch = (searchData) => {
  const searchTerms = new URLSearchParams({
    ...searchData,
    searchTerm: searchData.searchTerm.trim(),
  });

  const search = axios.get(`/customer/grid?${searchTerms}`).then((response) => response.data);

  return from(search);
};

export const getCustomerPreviousOrders = (customerId) => {
  const { collectionFilterName, apiFilter } = generateApiCollectionFilter(id, [customerId]);
  const getAndTransform = axios
    .post('/ordergrid/shipmentmode/simple', {
      filter: {
        [collectionFilterName]: apiFilter,
      },
    })
    .then((response) => {
      return get(response, 'data', { orders: [] });
    });

  const orders$ = from(getAndTransform);
  return orders$;
};

export const postCombinePayload = (combinePayload) => {
  const removeSurvivorId = combinePayload.shift();
  const deactivatedCustomerIds = combinePayload;

  const request = axios.post('/customer/combine', {
    survivingCustomerId: removeSurvivorId,
    deactivatedCustomerIds,
  });
  const data$ = from(request);
  return data$;
};

export const createCustomer = (customerData) => {
  const request = axios.post('/customer', customerData);
  return from(request);
};

export const deleteCustomer = (customerId) => {
  const request = axios.delete(`/customer/${customerId}`);
  return from(request);
};

export const updateCustomer = (customerId, customerData) => {
  const request = axios.put(`/customer/${customerId}`, customerData);
  return from(request);
};
